<!-- Com a home na carteira (`showsWalletPanels`) o convite a assinar é o banner novo abaixo; no pacote fica o de sempre. -->
<app-plan-message *ngIf="!showsWalletPanels"></app-plan-message>

<app-two-factor-notice></app-two-factor-notice>

<!-- `dashboard-section` desceu do `app-page-title` para o contêiner: é o
     marcador que o Cypress usa para saber que caiu no painel, e o cabeçalho
     agora depende da coorte do usuário. O contêiner não depende. -->
<div class="dashboard" data-testid="dashboard-section">
  <!-- Banner de planos (CU-86akn0zp6): para quem a home fala de carteira (coorte ou SMS/ligação
       na carteira — `showsWalletPanels`) e NÃO tem assinatura. Quem já assina não precisa ser
       convidado a assinar. -->
  <div class="plans-banner" *ngIf="showPlansBanner" data-testid="plans-banner">
    <p>
      <strong>Assine nosso plano</strong>
      <span>e recarregue com melhores valores</span>
    </p>
    <a class="plans-banner__action" [href]="plansCheckoutUrl" target="_blank" rel="noopener" data-testid="plans-banner-link">Ver Planos</a>
  </div>

  <!-- Cabeçalho: quem é a tela, o que ela mostra e de qual canal. Vale para as
       duas coortes (CU-86ak77za5): o seletor de canal governa o gráfico, e
       WhatsApp e IA já saem da carteira para todo mundo. -->
  <header class="page-head" data-testid="dashboard-head">
    <div class="page-head__identity">
      <span class="page-head__icon"><i class="fa fa-tachometer"></i></span>
      <div>
        <h1 class="page-head__title">Dashboard</h1>
        <p class="page-head__subtitle">Visão consolidada de saldo, disparos e conversões</p>
      </div>
    </div>

    <!-- "Tudo" mostra todas as séries; um canal deixa só a dele. Ligações somem
         no internacional, como já somem do menu: a operação internacional não
         disca. -->
    <!-- Com o RCS o grupo ganha o sexto botão: no celular ele usa o ajuste do seletor de canal
         do envio RCS e quebra em linhas (`rcs-channel`, global em `_rcs.scss`, porque o SCSS
         deste componente já passa do orçamento), em vez de cortar os últimos botões. -->
    <div class="sf-btn-group" role="group" aria-label="Canal" data-testid="channel-segmented"
      [class.rcs-channel]="showsRcs" [class.rcs-channel--wrap]="showsRcs">
      <button type="button" class="sf-btn sf-btn--sm" *ngFor="let option of channelOptions"
        [class.is-active]="channel === option.id"
        [attr.aria-pressed]="channel === option.id" (click)="selectChannel(option.id)"
        [attr.data-testid]="'channel-' + option.id">
        <i class="fa {{ option.icon }}"></i>
        <span>{{ option.label }}</span>
      </button>
    </div>
  </header>
  <!-- Carteira em R$ (CU-86akm3435 / CU-86akn0zp6): um cartão só, com o saldo à
       esquerda e tarifa e consumo à direita. Desde 29/09/2026 aparece para TODO
       cliente com algum canal cobrado pela carteira (WhatsApp e IA já são, para
       todo mundo), e não só para a coorte. SMS e ligação no pacote continuam nos
       cartões de contratados/enviados/disponíveis abaixo. -->
  <section class="wallet-card" *ngIf="showWalletCard" data-testid="wallet-balance-section">
    <app-skeleton *ngIf="loadingBalance" variant="card" [count]="1"
      label="Carregando o saldo da carteira" data-testid="wallet-balance-loading"></app-skeleton>

    <!-- 403: a conta está na coorte mas a cobrança pela carteira ainda não foi
         ligada no ambiente. Não é falha, e por isso não usa o braço de erro. -->
    <div class="panel panel--empty" *ngIf="!loadingBalance && isWalletDisabled" data-testid="wallet-disabled">
      <i class="fa fa-lock"></i>
      <p>{{ balanceError.message }}</p>
    </div>

    <div class="panel panel--empty" *ngIf="!loadingBalance && balanceError && !isWalletDisabled"
      data-testid="wallet-balance-error">
      <i class="fa fa-exclamation-triangle"></i>
      <p>{{ balanceError.message }}</p>
      <button type="button" class="sf-btn sf-btn--primary sf-btn--sm" (click)="loadWallet()"
        data-testid="wallet-retry">Tentar novamente</button>
    </div>

    <div class="row g-4 align-items-center" *ngIf="!loadingBalance && balance">
      <!-- Saldo: 5 de 12 colunas, como no protótipo. -->
      <div class="col-12 col-lg-5 wallet-card__balance" data-testid="wallet-available">
        <div class="wallet-card__balance-body">
          <span class="wallet-card__icon"><i class="fa fa-money"></i></span>
          <div>
            <p class="metric__label">
              Saldo geral da conta
              <button type="button" class="wallet-card__eye" (click)="toggleValuesVisibility()"
                [attr.aria-label]="valuesHidden ? 'Mostrar valores' : 'Ocultar valores'"
                [ngbTooltip]="valuesHidden ? 'Mostrar valores' : 'Ocultar valores'"
                data-testid="toggle-values">
                <i class="fa" [class.fa-eye]="valuesHidden" [class.fa-eye-slash]="!valuesHidden"></i>
              </button>
            </p>

            <!-- O `title` guarda o valor cheio para quem for conferir a soma dos
                 lançamentos contra o card — e some junto quando o valor está
                 escondido, senão o número voltaria no hover. -->
            <!-- `attr.title` e não `title`: a propriedade do DOM converte
                 `null` na STRING "null", e o valor cheio voltaria no hover
                 escrito por extenso. O atributo simplesmente some. -->
            <p class="metric__value" [attr.title]="valuesHidden ? null : (balance.available_micros | moneyMicros : currency)">
              {{ valuesHidden ? maskedValue : (balance.available_micros | moneyMicros : currency : balanceLocale : balanceFractionDigits) }}
            </p>

            <p class="metric__hint" data-testid="wallet-scope-hint">{{ walletScopeHint }}</p>
            <p class="metric__hint" [title]="balance.held_micros | moneyMicros : currency">
              {{ balance.held_micros | moneyMicros : currency : balanceLocale : balanceFractionDigits }} reservados em envios
            </p>
          </div>
        </div>

        <button type="button" class="sf-btn sf-btn--primary sf-btn--pill wallet-card__add" (click)="openRecharge()"
          data-testid="btn-add-balance">
          Adicionar saldo
          <i class="fa fa-plus-circle"></i>
        </button>
      </div>

      <!-- Tarifa e consumo: 7 de 12 colunas, dois sub-cartões. -->
      <div class="col-12 col-lg-7">
        <div class="row g-3">
          <div class="col-12 col-sm-6">
            <div class="sub-card" data-testid="active-rate">
              <p class="metric__label"><i class="fa fa-usd"></i> Tarifa ativa</p>

              <app-skeleton *ngIf="loadingPrices" variant="text" [count]="2"
                label="Carregando a tarifa ativa" data-testid="rate-loading"></app-skeleton>

              <!-- Tudo e IA não têm uma tarifa só: dizer "sem preço definido"
                   leria como envio bloqueado. -->
              <p class="sub-card__value sub-card__value--muted" *ngIf="!loadingPrices && selectedRateNote"
                data-testid="rate-note">{{ selectedRateNote }}</p>

              <ng-container *ngIf="!loadingPrices && !selectedRateNote">
                <!-- Sem preço resolvido não existe número: `R$ 0,00` leria como
                     envio de graça, que é o oposto de envio bloqueado. -->
                <p class="sub-card__value sub-card__value--muted" *ngIf="isSelectedPriceBlocked"
                  data-testid="rate-blocked">sem preço definido</p>

                <p class="sub-card__value" *ngIf="!isSelectedPriceBlocked">
                  <!-- Escala PADRÃO do pipe (mínimo 2, teto 6), não a do card:
                       preço unitário de WhatsApp vive em R$ 0,045 e arredondado
                       em 2 casas viraria R$ 0,05 — 11% a mais do que custa. -->
                  <strong data-testid="rate-value">
                    {{ selectedPrice.unit_price_micros | moneyMicros : currency }}
                  </strong>
                  <span class="sub-card__unit">{{ selectedPriceSuffix }}</span>
                </p>

                <span class="source-badge" *ngIf="!isSelectedPriceBlocked" data-testid="rate-source">
                  {{ selectedPriceSourceLabel }}
                </span>
              </ng-container>
            </div>
          </div>

          <div class="col-12 col-sm-6">
            <div class="sub-card" data-testid="channel-spent">
              <p class="metric__label"><i class="fa fa-arrow-down"></i> Total consumido</p>

              <app-skeleton *ngIf="loadingUsage" variant="text" [count]="2"
                label="Somando o consumo do canal" data-testid="spent-loading"></app-skeleton>

              <ng-container *ngIf="!loadingUsage">
                <!-- Resumo fora do ar não vira número: soma parcial com cara
                     de total é pior do que não somar. -->
                <p class="sub-card__value sub-card__value--muted" *ngIf="usageError"
                  data-testid="spent-unavailable">—</p>

                <p class="sub-card__value" *ngIf="!usageError">
                  <strong data-testid="spent-value">
                    {{ valuesHidden ? maskedValue : (selectedUsageMicros | moneyMicros : currency : balanceLocale : balanceFractionDigits : balanceFractionDigits) }}
                  </strong>
                </p>

                <span class="sub-card__hint">
                  {{ startedDay | date : "dd/MM" }} a {{ endedDay | date : "dd/MM" }}
                </span>
              </ng-container>
            </div>
          </div>
        </div>
      </div>
    </div>
  </section>

  <!-- Esqueleto por requisição (CU-86akkqppg): os cartões de crédito aparecem
       quando `userCreditsInfo` responde, sem esperar gráfico nem histórico. -->
  <div class="mb-3" *ngIf="loadingCredits" data-testid="credits-loading">
    <app-skeleton variant="card" [count]="4" label="Carregando seus créditos"></app-skeleton>
  </div>

  <ng-container *ngIf="!loadingCredits && creditInfo">
    <!-- SMS: pacote e quantidade, também na coorte enquanto o canal não for R$ -->
    <section class="channel" *ngIf="showSmsCredits" data-testid="sms-credits-section">
      <header class="channel__head">
        <span class="channel__badge"><i class="fa fa-comment"></i></span>
        <h2 class="channel__title">SMS</h2>
      </header>

      <div class="metric-grid">
        <div class="metric" data-testid="contracted-credits">
          <span class="metric__icon"><i class="fa fa-money"></i></span>
          <div class="metric__body">
            <p class="metric__label">SMS Contratados</p>
            <p class="metric__value">{{ creditInfo.total_contracted | numberFormat }}</p>
            <p class="metric__hint">Total de créditos</p>
          </div>
          <a class="metric__action" [routerLink]="['/recharges/new']" title="Comprar créditos de SMS">
            <i class="fa fa-plus-circle"></i>
          </a>
        </div>

        <div class="metric" data-testid="sent-credits">
          <span class="metric__icon"><i class="fa fa-envelope-o"></i></span>
          <div class="metric__body">
            <p class="metric__label">SMS Enviados</p>
            <p class="metric__value">{{ creditInfo.total_sent | numberFormat }}</p>
            <p class="metric__hint">Créditos utilizados</p>
          </div>
        </div>

        <!-- Disponível é o número que decide se o envio sai — mesma marcação da
             carteira. E o reservado, que até aqui só era subtraído em silêncio,
             passa a aparecer: sem ele o saldo parece encolher sozinho. -->
        <div class="metric metric--featured" data-testid="available-credits">
          <span class="metric__icon"><i class="fa fa-bank"></i></span>
          <div class="metric__body">
            <p class="metric__label">SMS Disponíveis</p>
            <p class="metric__value">{{ availableCredits | numberFormat }}</p>
            <p class="metric__hint">
              {{ creditInfo.total_reserved | numberFormat }} reservados em envios
            </p>
          </div>
        </div>

      </div>
    </section>

    <!-- Ligações: mesmo critério do SMS -->
    <section class="channel" *ngIf="showCallCredits" data-testid="call-credits-section">
      <header class="channel__head">
        <span class="channel__badge channel__badge--calls"><i class="fa fa-phone"></i></span>
        <h2 class="channel__title">Ligações</h2>
      </header>

      <div class="metric-grid">
        <div class="metric">
          <span class="metric__icon"><i class="fa fa-money"></i></span>
          <div class="metric__body">
            <p class="metric__label">Ligações Contratadas</p>
            <p class="metric__value">{{ (creditInfo.call_total_contracted || 0) | numberFormat }}</p>
            <p class="metric__hint">Total de créditos</p>
          </div>
          <a class="metric__action" [routerLink]="['/recharges/new']" [queryParams]="{target: 'call'}"
            title="Comprar créditos de ligação">
            <i class="fa fa-plus-circle"></i>
          </a>
        </div>

        <div class="metric">
          <span class="metric__icon"><i class="fa fa-phone"></i></span>
          <div class="metric__body">
            <p class="metric__label">Ligações Enviadas</p>
            <p class="metric__value">{{ (creditInfo.call_total_sent || 0) | numberFormat }}</p>
            <p class="metric__hint">Créditos utilizados</p>
          </div>
        </div>

        <div class="metric metric--featured">
          <span class="metric__icon"><i class="fa fa-bank"></i></span>
          <div class="metric__body">
            <p class="metric__label">Ligações Disponíveis</p>
            <p class="metric__value">{{ availableCallCredits | numberFormat }}</p>
            <p class="metric__hint">
              {{ (creditInfo.call_total_reserved || 0) | numberFormat }} reservados em envios
            </p>
          </div>
        </div>
      </div>
    </section>

    <!-- WhatsApp (betaHml): contratado, enviado e disponível, para conta com o canal -->
    <!-- Pacote de WhatsApp saiu da home em 29/09/2026 para todo mundo: o WhatsApp é
         cobrado em R$ pela carteira e o saldo antigo de WhatsApp é considerado expirado. -->

    <!-- Inteligência artificial -->
    <!-- Na coorte a IA é cobrada em R$ (carteira): tokens de pacote não dizem nada. -->
    <section class="channel" *ngIf="hasAiTokens && billing?.ai !== 'wallet' && !showsWalletPanels">
      <header class="channel__head">
        <span class="channel__badge channel__badge--ai"><i class="fa fa-magic"></i></span>
        <h2 class="channel__title">Inteligência artificial</h2>
      </header>

      <div class="metric-grid">
        <div class="metric" data-testid="ai-tokens-contracted">
          <span class="metric__icon metric__icon--ai"><i class="fa fa-cubes"></i></span>
          <div class="metric__body">
            <p class="metric__label">Tokens IA Contratados</p>
            <p class="metric__value">{{ (creditInfo.ai_total_contracted || 0) | numberFormat }}</p>
            <p class="metric__hint">Total de tokens</p>
          </div>
        </div>

        <div class="metric" data-testid="ai-tokens-used">
          <span class="metric__icon metric__icon--ai"><i class="fa fa-bolt"></i></span>
          <div class="metric__body">
            <p class="metric__label">Tokens IA Usados</p>
            <p class="metric__value">{{ (creditInfo.ai_total_sent || 0) | numberFormat }}</p>
            <p class="metric__hint">Tokens consumidos</p>
          </div>
        </div>

        <div class="metric metric--featured" data-testid="ai-tokens-available">
          <span class="metric__icon metric__icon--ai"><i class="fa fa-magic"></i></span>
          <div class="metric__body">
            <p class="metric__label">Tokens IA Disponíveis</p>
            <p class="metric__value">{{ (creditInfo.ai_tokens || 0) | numberFormat }}</p>
            <p class="metric__hint">Saldo disponível</p>
          </div>
        </div>
      </div>
    </section>
  </ng-container>

  <!-- RCS (17tm466frtx): só para conta com RCS (`showsRcs` = flag da conta E o bloco `rcs` do
       `/daily-sents`, que o backend só manda com o canal ligado). Mesmo período do gráfico,
       mesmos cartões dos outros canais; o funil segue a base do relatório do envio. -->
  <section class="channel" *ngIf="showsRcs" data-testid="rcs-section">
    <header class="channel__head">
      <span class="channel__badge"><i class="fa fa-commenting"></i></span>
      <h2 class="channel__title">RCS &middot; {{ startedDay | date : "dd/MM" }} a {{ endedDay | date : "dd/MM" }}</h2>
    </header>

    <app-skeleton *ngIf="loadingSents" variant="card" [count]="5"
      label="Carregando os números do RCS" data-testid="rcs-loading"></app-skeleton>

    <div class="metric-grid" *ngIf="!loadingSents">
      <div class="metric" data-testid="rcs-sent">
        <span class="metric__icon"><i class="fa fa-commenting"></i></span>
        <div class="metric__body">
          <p class="metric__label">Enviados por RCS</p>
          <p class="metric__value">{{ rcsSeries.totals.sent | numberFormat }}</p>
          <p class="metric__hint">Saíram pelo RCS no período</p>
        </div>
      </div>

      <!-- Sem o retorno do broker (`provider_status: false`) não há entregue nem lido: só enviados e cliques. -->
      <div class="metric" data-testid="rcs-delivered" *ngIf="rcsTracked">
        <span class="metric__icon"><i class="fa fa-check"></i></span>
        <div class="metric__body">
          <p class="metric__label">Entregues</p>
          <p class="metric__value">{{ rcsSeries.totals.delivered | numberFormat }}</p>
          <p class="metric__hint">{{ rcsDeliveredShare }} dos enviados</p>
        </div>
      </div>

      <div class="metric" data-testid="rcs-read" *ngIf="rcsTracked">
        <span class="metric__icon"><i class="fa fa-eye"></i></span>
        <div class="metric__body">
          <p class="metric__label">Lidos</p>
          <p class="metric__value">{{ rcsSeries.totals.read | numberFormat }}</p>
          <p class="metric__hint">{{ rcsReadShare }} dos entregues</p>
        </div>
      </div>

      <div class="metric" data-testid="rcs-clicks">
        <span class="metric__icon"><i class="fa fa-hand-pointer-o"></i></span>
        <div class="metric__body">
          <p class="metric__label">Cliques</p>
          <p class="metric__value">{{ rcsSeries.totals.clicks | numberFormat }}</p>
          <p class="metric__hint">{{ rcsTracked ? 'Em botões e links do RCS' : 'Nos links curtos do RCS' }}</p>
        </div>
      </div>

      <!-- Quem não tem RCS no aparelho (ou o broker recusou) recebe SMS: é o número que
           explica por que o envio RCS também gasta SMS. -->
      <div class="metric" data-testid="rcs-sms-fallback">
        <span class="metric__icon"><i class="fa fa-comment"></i></span>
        <div class="metric__body">
          <p class="metric__label">Viraram SMS</p>
          <p class="metric__value">{{ rcsSeries.totals.sms_fallback | numberFormat }}</p>
          <p class="metric__hint">{{ rcsFallbackShare }} das mensagens, sem RCS no aparelho ou recusadas</p>
        </div>
      </div>
    </div>
  </section>

  <div class="row">
    <!-- O anel "Consumo do contratado" saiu em 01/10/2026 (Bruno): IA não tem mais pacote e, para
         quem migrou, o contratado não diz nada. O gráfico de envios fica com a largura toda. -->
    <!-- 07/10/2026 (Bruno): com o "Gasto por canal" na tela, ele vai à direita do gráfico. -->
    <div class="col-12 mb-3 d-flex" [class.col-xl-8]="showsWalletPanels">
      <div class="panel panel--chart">
        <header class="panel__head">
          <div>
            <h3 class="panel__title">Envios por dia</h3>
            <p class="panel__subtitle">
              {{ startedDay | date : "dd/MM/yyyy" }} a {{ endedDay | date : "dd/MM/yyyy" }}
            </p>
          </div>

          <div class="panel__controls">
            <!-- Janela do gráfico. O teto de 30 dias é o mesmo do protótipo, e
                 o campo de data continua ao lado para quem quer outro recorte. -->
            <div class="sf-btn-group" role="group" aria-label="Período do gráfico" data-testid="chart-period">
              <button type="button" class="sf-btn sf-btn--sm" *ngFor="let days of chartPeriodOptions"
                [class.is-active]="chartDays === days"
                [attr.aria-pressed]="chartDays === days"
                (click)="selectChartPeriod(days)"
                [attr.data-testid]="'chart-period-' + days">
                {{ days }}d
              </button>
            </div>

          </div>
        </header>

        <!-- O recorte é o seletor de canal do topo. Contagem (SMS, ligações) e
             gasto em R$ (WhatsApp, IA) aparecem lado a lado, nunca somados. -->
        <div class="panel__headline" *ngIf="!loadingChart" data-testid="chart-headline">
          <!-- Com um canal de contagem sem fonte, a soma seria só de parte dos envios:
               o aviso abaixo fica no lugar do total. -->
          <ng-container *ngIf="chartHasCountSeries && !chartCountUnavailable">
            <strong data-testid="chart-count-total">{{ periodTotal | numberFormat }}</strong>
            <span>{{ periodTotalLabel }} &middot; {{ periodDailyAverage | numberFormat }} por dia em média</span>
          </ng-container>

          <ng-container *ngIf="chartHasMoneySeries">
            <strong data-testid="chart-spent-total">
              {{ valuesHidden ? maskedValue : (periodSpentMicros | moneyMicros : 'BRL' : balanceLocale : balanceFractionDigits : balanceFractionDigits) }}
            </strong>
            <span>{{ periodSpentLabel }}</span>
          </ng-container>
        </div>

        <p class="panel__note" *ngIf="!loadingChart && chartCountUnavailable" data-testid="chart-count-unavailable">
          <i class="fa fa-info-circle"></i>
          Não foi possível carregar os envios do período.
        </p>

        <p class="panel__note" *ngIf="!loadingChart && chartSpendUnavailable" data-testid="chart-spend-unavailable">
          <i class="fa fa-info-circle"></i>
          Não foi possível somar o gasto em R$ de WhatsApp e IA neste período.
        </p>

        <div class="panel__filter">
          <mat-form-field *ngIf="messagesChartDateField" style="width:200px">
            <mat-label>Data inicial</mat-label>
            <input matInput [matDatepicker]="picker" [(ngModel)]="startedDay" name="startedDay"
              (dateChange)="onDateSelected($event)" [max]="now" [min]="minDate">
            <mat-datepicker-toggle matSuffix [for]="picker"></mat-datepicker-toggle>
            <mat-datepicker #picker></mat-datepicker>
          </mat-form-field>
          <small *ngIf="startedDay > now" class="text text-danger"
            >A data inicial não pode ser maior que a data de hoje.
          </small>
        </div>

        <app-skeleton *ngIf="loadingChart" variant="text" [count]="6"
          label="Carregando o gráfico de envios" data-testid="chart-loading"></app-skeleton>

        <apx-chart
          *ngIf="!loadingChart && messagesChartOptions"
          style="width: 100%"
          [series]="messagesChartOptions.series"
          [chart]="messagesChartOptions.chart"
          [tooltip]="messagesChartOptions.tooltip"
          [colors]="messagesChartOptions.colors"
          [grid]="messagesChartOptions.grid"
          [xaxis]="messagesChartOptions.xaxis"
          [yaxis]="messagesChartOptions.yaxis"
          [stroke]="messagesChartOptions.stroke"
          [fill]="messagesChartOptions.fill"
          [legend]="messagesChartOptions.legend"
          [dataLabels]="messagesChartOptions.dataLabels"
        >
        </apx-chart>
      </div>
    </div>

    <!-- Coorte: no lugar do anel de contratado — que não existe para quem não
         compra unidade — o que cada canal consumiu do saldo no período. -->
    <div class="col-12 col-xl-4 mb-3 d-flex" *ngIf="showsWalletPanels">
      <div class="panel panel--usage">
        <header class="panel__head">
          <div>
            <h3 class="panel__title">Gasto por canal</h3>
            <p class="panel__subtitle">
              {{ startedDay | date : "dd/MM/yyyy" }} a {{ endedDay | date : "dd/MM/yyyy" }}
            </p>
          </div>
        </header>

        <app-skeleton *ngIf="loadingUsage" variant="text" [count]="5"
          label="Somando o consumo do período" data-testid="wallet-usage-loading"></app-skeleton>

        <ng-container *ngIf="!loadingUsage">
          <div class="usage-notice" *ngIf="usageError" data-testid="wallet-usage-error">
            <i class="fa fa-exclamation-triangle"></i>
            <p>{{ usageError.message }}</p>
            <button type="button" class="sf-btn sf-btn--primary sf-btn--sm" (click)="loadWallet()">Tentar novamente</button>
          </div>

          <div class="usage-notice" *ngIf="!usageError && !hasUsage"
            data-testid="wallet-usage-empty">
            <i class="fa fa-inbox"></i>
            <p>Nenhum consumo no período.</p>
          </div>

          <ul class="usage-legend" *ngIf="!usageError && hasUsage"
            data-testid="wallet-usage-list">
            <li *ngFor="let entry of usage" class="usage-legend__item usage-legend__item--stacked">
              <span class="usage-legend__label">{{ entry.label }}</span>
              <span class="usage-legend__value">{{ entry.spentMicros | moneyMicros : currency : balanceLocale : balanceFractionDigits : balanceFractionDigits }}</span>
              <!-- A unidade vai junto do número porque ela muda de canal para
                   canal: mensagem no SMS, bloco de 30s na ligação, mil tokens na
                   IA. Sem ela, "1.200" em ligação passaria por 1.200 chamadas. -->
              <small class="usage-legend__hint">
                {{ entry.quantity === null ? 'sem contagem' : (entry.quantity | numberFormat) + ' ' + entry.unitLabel }}
              </small>
            </li>
          </ul>
        </ng-container>
      </div>
    </div>

  </div>

  <div class="row">
    <div class="col">
      <app-page-title
        icon="fa-paper-plane"
        title="Mensagens Enviadas"
        data-testid="test-page-title"
      >
        <a
          *ngIf="!loadingMessages && controls?.length > 0"
          [routerLink]="['/messages-report']"
          class="sf-btn sf-btn--primary sf-btn--sm"
          data-testid="link-more-messages"
        >
          Mais Mensagens
          <i class="fa fa-plus-circle"></i>
        </a>
      </app-page-title>

      <app-skeleton *ngIf="loadingMessages" variant="table-row" [count]="4" [columns]="3"
        label="Carregando as últimas mensagens" data-testid="messages-loading"></app-skeleton>

      <div class="panel panel--list" *ngIf="!loadingMessages && controls?.length > 0; else notFoundMessages">
        <app-accordion-panel
          *ngFor="let info of controls"
          [title]="info.message"
          data-testid="message-panel"
        >
          <div class="row message-line">
            <div class="col-md-3 col-sm-12">
              <i class="fa fa-user me-2"></i>{{ info.name }}
            </div>
            <div class="col-md-3 col-sm-12">
              <i class="fa fa-phone me-2"></i>{{ info.phone }}
            </div>
            <div class="col-md-3 col-sm-12">
              <i class="fa fa-calendar me-2"></i
              >{{ info.sent_date | date : "dd/MM/yyyy HH:mm" }}
            </div>
            <div class="col-md-3 col-sm-12" *ngIf="info.provider_account_name">
              <i class="fa fa-calendar me-2"></i
              >{{ info.provider_account_name }}
            </div>
          </div>
        </app-accordion-panel>
      </div>
    </div>
  </div>

  <div class="row mt-4">
    <div class="col">
      <app-page-title
        icon="fa-phone"
        title="Ligações Enviadas"
      >
        <a
          *ngIf="!loadingCalls && lastCalls?.length > 0"
          [routerLink]="['/calls-report']"
          class="sf-btn sf-btn--primary sf-btn--sm"
          data-testid="link-more-calls"
        >
          Mais Ligações
          <i class="fa fa-plus-circle"></i>
        </a>
      </app-page-title>

      <app-skeleton *ngIf="loadingCalls" variant="table-row" [count]="4" [columns]="3"
        label="Carregando as últimas ligações" data-testid="calls-loading"></app-skeleton>

      <div class="panel panel--list" *ngIf="!loadingCalls && lastCalls?.length > 0; else notFoundCalls">
        <app-accordion-panel
          *ngFor="let call of lastCalls"
          [title]="call.origin_name || 'Ligação'"
          data-testid="call-panel"
        >
          <div class="row message-line">
            <div class="col-md-3 col-sm-12">
              <i class="fa fa-user me-2"></i>{{ call.name || 'Sem nome' }}
            </div>
            <div class="col-md-3 col-sm-12">
              <i class="fa fa-phone me-2"></i>{{ call.phone }}
            </div>
            <div class="col-md-3 col-sm-12">
              <i class="fa fa-calendar me-2"></i
              >{{ call.sent_at | date : "dd/MM/yyyy HH:mm" }}
            </div>
            <div class="col-md-3 col-sm-12">
              <i class="fa fa-clock-o me-2"></i>{{ call.call_duration_seconds || 0 }}s
            </div>
          </div>
        </app-accordion-panel>
      </div>
    </div>
  </div>
</div>

<!-- O `*ngIf` do carregamento é o que impede "Nenhuma mensagem enviada!" de
     piscar antes da resposta: o ramo `else` já entra em cena enquanto a lista
     está vazia por não ter chegado ainda. -->
<!-- Erro não é vazio (CU-86akkvp5q): quando a lista falha, o bloco diz que não
     carregou e oferece nova tentativa, em vez de afirmar que não houve envio. -->
<ng-template #notFoundMessages>
  <div class="panel panel--empty" *ngIf="!loadingMessages && messagesError" data-testid="messages-error">
    <i class="fa fa-exclamation-triangle"></i>
    <p>Não foi possível carregar as últimas mensagens.</p>
    <button type="button" class="sf-btn sf-btn--primary sf-btn--sm" (click)="loadLastMessages()"
      data-testid="messages-retry">Tentar novamente</button>
  </div>
  <div class="panel panel--empty" *ngIf="!loadingMessages && !messagesError" data-testid="no-messages-card">
    <i class="fa fa-paper-plane"></i>
    <p>Nenhuma mensagem enviada!</p>
  </div>
</ng-template>

<ng-template #notFoundCalls>
  <div class="panel panel--empty" *ngIf="!loadingCalls && callsError" data-testid="calls-error">
    <i class="fa fa-exclamation-triangle"></i>
    <p>Não foi possível carregar as últimas ligações.</p>
    <button type="button" class="sf-btn sf-btn--primary sf-btn--sm" (click)="loadLastCalls()"
      data-testid="calls-retry">Tentar novamente</button>
  </div>
  <div class="panel panel--empty" *ngIf="!loadingCalls && !callsError" data-testid="no-calls-card">
    <i class="fa fa-phone"></i>
    <p>Nenhuma ligação enviada!</p>
  </div>
</ng-template>

<!-- Recarga por valor (CU-86akn0zp6). O modal mora aqui e a abertura é um valor
     empurrado no `Subject`, como já acontece com o modal da carteira no header. -->
<app-recharge-modal *ngIf="showWalletCard" [showModal]="showRechargeModal"
  (completed)="onRechargeCompleted()"></app-recharge-modal>
